module.exports = __webpack_public_path__ + "img/geod_12.f2c9df10.jpg";